// extracted by mini-css-extract-plugin
module.exports = {"Skills":"Skills_Skills__2xCDS","skillsSection":"Skills_skillsSection__5yQz_","secHover":"Skills_secHover__aGMch"};